var internet = {};
module['exports'] = internet;
internet.free_email = require("./free_email");
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_AT/internet/index.js
 ** module id = 249
 ** module chunks = 0
 **/